
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import DataImport from "@common/src/components/scope/data-import/index.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import ImportPartsInbound from "./components/import-parts-inbound.vue";
import t from "@common/src/i18n/t";
const base = namespace("base");
const staff = namespace("staff");
const inventory = namespace("inventory");
const management = namespace("management");
const app = namespace("app");

@InjectFunction("dayjs", "emptyToLine", "splitThousands", "permit", "permitApp", "appCode", "addCurrencySymbol")
@Component({
  components: { DataImport, ImportPartsInbound }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/speedbiz/template/2.10/入库单导入.xlsx",
  actionUrl: "/filecloud/importInbounds"
})
export default class InWarehouse extends Vue {
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @inventory.Action inWarehouseComplete;
  @management.Action getStoreList;
  @inventory.Action getInWarehouseList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  orderList: any[] = [];
  searchForm = {
    storeCode: "",
    inboundType: "",
    inboundUser: "",
    startInboundDate: "",
    endInboundDate: "",
    inboundStatus: "",
    customerPlateCode: "",
    orderNo: "",
    inboundNo: ""
  };
  orderStatusList: any[] = [];
  orderTypeList: any[] = [];
  staffList: any[] = [];
  created() {
    this.init();
    this.loadListData();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("inbound_status").then(data => {
      this.orderStatusList = data;
    });
    // 订单类型字典List
    this.getDictionaryList("inbound_type").then(data => {
      this.orderTypeList = data;
    });
    if (this.appCode === "speedbiz") {
      // 员工和顾问 List
      this.getStaffList({
        pageSize: 999,
        pageNum: 1
      }).then(data => {
        const staffList = this.$safeValue(data, "data.list", []).map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
        this.staffList = staffList;
      });
    }
  }
  totalPartsQty = "";
  totalCostAmount = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getInWarehouseList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = this.$safeValue(data, "data.list", []);
      this.totalPartsQty = this.$safeValue(data, "data.totalPartsQty", "");
      this.totalCostAmount = this.$safeValue(data, "data.totalCostAmount", "");
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  handleComplete() {
    this.btnStartLoading();
    this.inWarehouseComplete({
      inboundNo: this.activeRow.inboundNo
    })
      .then(() => {
        this.$message.success(t("warehouse.inbound-success") as string);
        this.loadListData();
        this.showInConfirmTips = false;
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  get searchList() {
    return [
      ...(this.appCode === "speedbiz-operation"
        ? [
            {
              label: t("v210831.store-name"),
              type: "select-search",
              value: "",
              prop: "storeCode",
              placeholder: t("v210801.please-enter-keyword"),
              selectList: this.storeList,
              searchFun: this.searchStore
            }
          ]
        : []),
      {
        label: "warehouse.inbound-type",
        type: "select",
        selectList: this.orderTypeList,
        value: "",
        prop: "inboundType"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "warehouse.inbound-people",
              type: "select",
              selectList: this.staffList,
              value: "",
              prop: "inboundUser"
            }
          ]
        : []),
      {
        label: "warehouse.inbound-date",
        type: "daterange",
        value: "",
        prop: "startInboundDate"
      },
      {
        label: "v213.Inbound-status",
        type: "select",
        selectList: this.orderStatusList,
        value: "",
        prop: "inboundStatus"
      },
      {
        label: "other.relation-vehicle",
        type: "input",
        value: "",
        prop: "customerPlateCode"
      },
      {
        label: "v213.Related-order-No",
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: "v213.Inbound-No",
        type: "input",
        value: "",
        prop: "inboundNo"
      },
      {
        label: t("v216_g.related_purchase_no"),
        type: "input",
        value: "",
        prop: "purchaseNo"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "startInboundDate") {
          this.searchForm["startInboundDate"] = item.value ? item.value[0] : "";
          this.searchForm["endInboundDate"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleEdit(row) {
    this.$router.push(`/inventory/in-warehouse-edit/${row.inboundNo}`);
  }
  handleLinkPurchaseView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.purchaseNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}?tenantCode=${row.tenantCode || ""}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/inventory/in-warehouse-view/${row.inboundNo}`
    });
    window.open(href, "_blank");
  }
  storeList: any = [];
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
  handleShowTogetherImport() {
    (this.$refs["importPartsInbound"] as any).mix_handleShowImportModal();
  }
  // 2.10
  activeRow: any = {};
  showInConfirmTips: boolean = false;
  handleShowInConfrimTips(row) {
    this.showInConfirmTips = true;
    this.activeRow = row;
  }
}
